import { Form, Formik } from 'formik';
import { useState } from 'react';
import { toast } from 'react-toastify';
import * as yup from 'yup';

import settingsApi from '../../../APIs/settings';
import { AuthType, useRoot } from '../../../context/RootProvider';
import {
  BrowseFile,
  Button,
  FormContainer,
  Typography,
} from '../../../designComponents';
import { requestAPI, uploadFilesToS3 } from '../../../utils';
import { ActiveComponentType } from '.';
import { Container } from './onboardingForms.style';

const validationSchema = yup.object({
  profileImage: yup.array().nullable().min(1, 'Profile picture is required'),
});
const UploadProfileImage = ({ setCurrentStep }: ActiveComponentType) => {
  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const { auth: user, updateAuth } = useRoot();

  const handleUploadPhoto = async () => {
    try {
      if (files && files.length === 0) {
        return;
      }
      setLoading(true);
      const uploadedKeys = await uploadFilesToS3(files);
      if (uploadedKeys && uploadedKeys?.length > 0) {
        const avatarUrls = uploadedKeys[0].key;
        await requestAPI(
          settingsApi.updatePersonalInfo({
            avatar: avatarUrls,
            fullName: user?.fullName,
          }),
        );
        const updatedData = { ...user } as AuthType;
        if (updatedData) {
          updatedData.avatar = avatarUrls || '';
        }
        updateAuth(updatedData);
        toast.success('Photo uploaded successfully');
        setLoading(false);
        setCurrentStep((prev) => prev + 1);
      }
    } catch (error) {
      console.error('Error uploading photo:', error);
      toast.error('Failed to upload photo');
      setLoading(false);
    }
  };

  return (
    <Container>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
        <Typography variant="title" strong>
          Upload your profile picture
        </Typography>

        <Formik
          validationSchema={validationSchema}
          initialValues={{ profileImage: [] }}
          onSubmit={handleUploadPhoto}
        >
          {({ values, touched, errors, setFieldValue }) => {
            return (
              <Form>
                <FormContainer
                  label="Profile Image"
                  error={
                    touched.profileImage &&
                    values.profileImage.length === 0 &&
                    typeof errors.profileImage === 'string'
                      ? errors.profileImage
                      : ''
                  }
                >
                  <BrowseFile
                    files={files}
                    setFiles={(selectedfiles: File[]) => {
                      selectedfiles.splice(1, selectedfiles.length - 1);

                      setFieldValue('profileImage', selectedfiles);
                      setFiles(selectedfiles);
                    }}
                    accepts=".png, .svg, .jpeg"
                    showFileBrowser={files.length === 0}
                  />
                </FormContainer>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <Button
                    width="93px"
                    variant="gray"
                    onClick={() => setCurrentStep((prev) => prev + 1)}
                  >
                    Skip
                  </Button>
                  <Button
                    variant="secondary"
                    width="120px"
                    isLoading={loading}
                    type="submit"
                  >
                    Continue
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};

export default UploadProfileImage;
